module.exports = __webpack_public_path__ + "static/media/m-media-img.2bc77901.png";